export enum FilterChipTypeEnum {
  grouper = 'grouper',
  brand = 'brand',
}
